function isMobileMediaQuery(theme) {
  var _mobile;
  return typeof (theme === null || theme === void 0 || (_mobile = theme.mobile) === null || _mobile === void 0 ? void 0 : _mobile.mediaQuery) === 'string';
}

export { isMobileMediaQuery as i };
//# sourceMappingURL=isMobileMediaQuery-D1hSN0DH.js.map
